import React, { useEffect, useRef } from "react";
import { RichText } from "prismic-reactjs";

import Grid from "@commerce-ui/core2/Grid";
import Box from "@commerce-ui/core2/Box";
import Container from "@commerce-ui/core2/Container";
import LinkRaw from "@commerce-ui/core2/LinkRaw";

import ProductBox from "../../components/ProductBox";
import RectangleCardWithLabelBoxInside from "../../components/RectangleCardWithLabelBoxInside";
import CardsSlider from "../../components/CardsSlider";
import CategorySubmenu from "@deosite/components-new/CategorySubmenu"; // TODO: przerobic import

import PageContainer from "../../containers/UI/PageContainer";

import SectionWithConfigurableHeader from "../../sections/SectionWithConfigurableHeader";

import useAnalyticsAndCommerceTags from "@deosite/api/hooks/common/useAnalytics4AndCommerceTags";
import { useLanguage } from "@deosite/api/hooks/common/LanguageProvider";

import translate from "@deosite/helpers/langLibrary";
import { getDefaultCategoryProductImage } from "@deosite/helpers/getDefaultProductImage";

import { useRouteContext } from "@deosite/lib/RouteContext";

const CategoryPage = props => {
  const {
    subcategoryForLeftColumn,
    categoryProducts,
    currentCategory,
    parentCategory,
    backLabel,
    backClickFunction,
    footerContent,
    pagination,
    filtersBar,
    categoriesSliderMobile,
    dataRequiredToHideLoader,
    prismicData,
    categoryBanner,
    filtersString = "",
    isDefaultView = true,
    externalHtml = "",
    totalCount = "",
    isSearchPage = false
  } = props;
  const { language } = useLanguage();
  const { Link } = useRouteContext();

  const translations = {
    seoDescription: translate("Default seo description"),
    seoTitle: translate("Default seo title")
  };

  const { viewList } = useAnalyticsAndCommerceTags();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      viewList(
        categoryProducts,
        currentCategory?.name,
        isSearchPage ? "search_results" : "category",
        isSearchPage
          ? "search"
          : "category-" + currentCategory?.name.replace(" ", "-")
      );
    }
  });

  let products = categoryProducts.map((product, index) => (
    <ProductBox
      key={index}
      product={product}
      otherDefaultImage={getDefaultCategoryProductImage(
        global.__appConfig__.categoryDefaultImage,
        language?.language,
        product
      )}
      parentListType={isSearchPage ? "search" : "category"}
      parentListIndex={index}
    />
  ));

  categoryBanner &&
    products.splice(
      categoryBanner.position - 1,
      0,
      <RectangleCardWithLabelBoxInside
        key={"saleBox"}
        link={categoryBanner.url ? categoryBanner.url : " "}
        label={categoryBanner.text}
        image={categoryBanner.image}
      />
    );

  const descriptionBox = (
    <Box>
      {prismicData?.content?.description && (
        <Box sx={{ mt: "s12" }}>
          <Box
            sx={{
              borderTop: "1px",
              borderTopColor: "neutral500",
              borderStyle: "solid",
              height: "1px"
            }}
          />
          <Box
            sx={{
              font: "base",
              color: "main",
              pt: "s9",
              pb: "s9",
              h5: { font: "l", pt: "0px", pb: "0px", m: "0px" },
              ul: { mb: "s0" },
              p: { my: "s7" },
              a: { color: "main", fontWeight: 700 }
            }}
          >
            {RichText.render(prismicData.content?.description.content)}
          </Box>

          <Box
            sx={{
              borderTop: "1px",
              borderTopColor: "neutral500",
              borderStyle: "solid",
              height: "1px"
            }}
          />
        </Box>
      )}
    </Box>
  );

  const rightColumn = (
    <Box>
      <Box
        sx={{
          mb: "s9"
        }}
      >
        {categoriesSliderMobile}
      </Box>
      {filtersBar}
      <Box
        sx={{
          mb: "s9"
        }}
      >
        {pagination}
      </Box>
      <Grid cols={[2, 2, 3, 3]} sx={{ gridRowGap: "s11", mt: "s7" }}>
        {products}
      </Grid>
    </Box>
  );

  let subcategoriesHaveNoChildren = true;
  subcategoryForLeftColumn?.find(category => {
    if (category.subcategories.length > 0) {
      subcategoriesHaveNoChildren = false;
    }
  });

  let displayCurrentCategoryName = true;
  subcategoryForLeftColumn?.find(category => {
    if (category.id === currentCategory.id) {
      displayCurrentCategoryName = false;
    }
  });

  const parentCategoryHeaderData = displayCurrentCategoryName
    ? currentCategory
    : parentCategory;

  return (
    <PageContainer
      key={currentCategory?.name}
      footerContent={footerContent}
      products={products}
      returnLinkLabel={backLabel}
      onReturnLabelClick={backClickFunction}
      metaTagsData={{
        description: translations.seoDescription,
        title: translations.seoTitle
      }}
      dataRequiredToHideLoader={dataRequiredToHideLoader}
      externalIntegrationsHtml={externalHtml.length > 0 ? externalHtml : ""}
    >
      <SectionWithConfigurableHeader
        title={
          currentCategory?.name
            ? `${filtersString} ${currentCategory?.name} (${totalCount})`
            : filtersString
        }
      >
        {isDefaultView ? (
          <Box sx={{ mt: ["s9", 0, null] }}>
            <Container>
              {filtersBar}
              <Box sx={{ mt: "s3", mb: "s9" }}>{pagination}</Box>
              <Box data-test={"product-container"}>
                <Grid cols={[2, 2, 4, 4]}>{products}</Grid>
                <Box sx={{ mt: "s12" }}>{pagination}</Box>
                {pagination.props.currentPage === 1 && descriptionBox}
              </Box>
            </Container>
          </Box>
        ) : (
          <Box>
            <Box sx={{ mb: "s9" }}>
              {prismicData?.content?.tiles && (
                <CardsSlider
                  itemsGap={"16px"}
                  itemsVisible={[1.5, null, 3, null, 5]}
                >
                  {prismicData.content.tiles.map((tile, index) => (
                    <RectangleCardWithLabelBoxInside
                      key={index}
                      link={tile.url}
                      label={tile.title}
                      image={tile.image}
                      promoLabel={tile.promoLabel}
                    />
                  ))}
                </CardsSlider>
              )}
            </Box>
            <Container>
              <Grid cols={[24, null, null, 20]}>
                <Box
                  sx={{
                    gridColumnStart: 1,
                    gridColumnEnd: 5,
                    gridRowStart: "row1-start",
                    gridRowEnd: 2,
                    display: ["none", null, null, "grid"]
                  }}
                >
                  <Box>
                    {subcategoriesHaveNoChildren && (
                      <Box
                        sx={{
                          font: "base_sans_bold",
                          mb: "s6",
                          color: "main"
                        }}
                      >
                        <Link
                          route={"category-page"}
                          params={{ url: parentCategoryHeaderData.url }}
                        >
                          <LinkRaw title={parentCategoryHeaderData.name}>
                            {parentCategoryHeaderData.name}
                          </LinkRaw>
                        </Link>
                      </Box>
                    )}
                    {subcategoryForLeftColumn?.map(subcategory => (
                      <CategorySubmenu
                        underlineAsActive={
                          subcategoriesHaveNoChildren &&
                          subcategory.id === currentCategory.id
                        }
                        hasNoChildren={subcategoriesHaveNoChildren}
                        submenu={subcategory}
                      />
                    ))}
                  </Box>
                </Box>

                <Box
                  sx={{
                    gridColumnStart: [1, null, null, 5, null],
                    gridColumnEnd: [25, null, null, 21],
                    gridRowStart: "row6-start",
                    gridRowEnd: 2
                  }}
                >
                  {rightColumn}
                </Box>
              </Grid>
              <Box sx={{ mt: "s12" }}>{pagination}</Box>
              {pagination.props.currentPage === 1 && descriptionBox}
            </Container>
          </Box>
        )}
      </SectionWithConfigurableHeader>
    </PageContainer>
  );
};

export default CategoryPage;
